import FeeInput from './FeeInput';

export default FeeInput;
